import { createContext, useContext, useEffect, useReducer, useState } from "react";
import axios from "axios";
import reducer from "../reducer/productReducer"

const AppContext = createContext();
const API = "https://ecomm-backend-htia.onrender.com/api/products";
const intialState ={
  isLoading: false,
  isError: false,
  products:[],
  featureProducts:[],
  isSingleLoading:false,
  singleProduct:{}
};



const AppProvider = ({children}) =>{
const [isLoading, setIsLoading] = useState(false);

  const [state, dispatch] = useReducer(reducer, intialState);

    const getProducts = async(url) =>{
      setIsLoading(true);
      dispatch({type:"SET_LOADING"})
      try{
      const res =  await axios.get(url);
      const products = await res.data;
      dispatch({type:"SET_API_DATA", payload: products});
      setIsLoading(false);
      }catch(error){
      setIsLoading(false);
        dispatch({type:"API_ERROR"});
      }
      
    };

    // API call for single Product

    const getSingleProduct = async (url) => {
    dispatch({ type: "SET_SINGLE_LOADING" });
    try {
        const res = await axios.get(url);
        const singleProduct = res.data;
        dispatch({ type: "SET_SINGLE_PRODUCT", payload: singleProduct });
    } catch (error) {
        dispatch({ type: "SET_SINGLE_ERROR" });
    }
};

    useEffect(()=>{ 
        getProducts(API);
    },[])

    return(
    <AppContext.Provider value={{...state,getSingleProduct}}>{children}</AppContext.Provider>);
};

// custom Hook
const useProductContext = ()=>{ 
    return  useContext(AppContext)
}
 export {AppProvider, AppContext, useProductContext};